import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, ScreenName, Screens} from './Screens';
import HeaderBackButton from 'components/atoms/headerBackButton';
import strings from '../translations';
import styleSheet from './styles';
import {RouteProp} from '@react-navigation/native';
import {Platform} from 'react-native';
import {GroupType} from 'models/Admin';

const Stack = createNativeStackNavigator();

export interface AdminPanelGroupsInteractionProps {
  title: string;
  id?: string;
}

export interface AdminPanelGroupsScreenProps {
  navigation: NativeStackNavigationProp<{
    [ScreenName.adminPanelGroups]: undefined;
    [ScreenName.adminPanelGroupsInteraction]: AdminPanelGroupsInteractionProps;
  }>;
}

export interface AdminPanelGroupsInteractionScreenProps {
  navigation: NativeStackNavigationProp<{
    [Flows.adminPanelGeneralFlow]: undefined;
    [Flows.adminPanelGroupsFlow]: undefined;
  }>;
  route: any;
}

const GroupsFlow = () => {
  const theme = useTheme();
  const styles = styleSheet(useTheme());

  return (
    <Stack.Navigator
      screenOptions={({navigation, route}) => ({
        headerLeft: () => <HeaderBackButton onPress={() => navigation.pop()} />,
        headerStyle: styles.headerStyle,
        headerTitleStyle: styles.headerTitleStyle,
        headerTitleAlign: 'center',
        headerShadowVisible: false,
      })}>
      <Stack.Screen
        name={Screens.AdminPanelGroupsScreen.name}
        component={Screens.AdminPanelGroupsScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.AdminPanelGroupsInteractionScreen.name}
        component={Screens.AdminPanelGroupsInteractionScreen.screen}
        options={{headerShown: false}}
      />
    </Stack.Navigator>
  );
};

export default GroupsFlow;
